exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sidebar__header[data-v-d46729a2] {\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  min-height: 47px;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n.sidebar__header__clear[data-v-d46729a2] {\n    font-size: .8em;\n    min-width: 102px;\n}\n@media only screen and (min-width: 769px) and (max-width: 770px) {\n.sidebar__header__clear[data-v-d46729a2] {\n        margin-top: 20px;\n}\n}\n.sidebar__inline-selecors[data-v-d46729a2] {\n  display: -ms-flexbox;\n  display: flex;\n}\n.mobile-category-filter[data-v-d46729a2] {\n  display: block;\n}\n", ""]);

// exports
